import { render, staticRenderFns } from "./bidListMgmt.vue?vue&type=template&id=38feb6e4&scoped=true"
import script from "./bidListMgmt.vue?vue&type=script&lang=js"
export * from "./bidListMgmt.vue?vue&type=script&lang=js"
import style0 from "./bidListMgmt.vue?vue&type=style&index=0&id=38feb6e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38feb6e4",
  null
  
)

export default component.exports